import { IconButton, InputAdornment, TextField, useTheme } from '@mui/material'
import { Clear, Search } from '@mui/icons-material'
import React from 'react'

const SearchInput = ({ isLoading, value, onChange }) => {
  const { palette } = useTheme()

  return (
    <TextField
      id='catalog-filter-search'
      label='Search'
      variant='outlined'
      value={value}
      size='small'
      autoComplete='off'
      disabled={isLoading}
      onChange={event => { onChange(event.target.value) }}
      InputLabelProps={{ style: { color: palette.text.disabled }, size: 'small' }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='clear search term'
              onClick={() => onChange('')}
              edge='start'
              style={{ color: palette.text.disabled, visibility: value.length ? 'visible' : 'hidden' }}
              tabIndex={value.length ? 0 : -1}
              size='large'
            >
              <Clear />
            </IconButton>
            <Search style={{ color: palette.text.disabled }} />
          </InputAdornment>
        )
      }}
    />
  )
}

export default SearchInput
